
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M12.5 7.5a.5.5 0 00-1 0v4.73l3.675 3.15a.5.5 0 10.65-.76L12.5 11.77V7.5z"}}),_c('path',{attrs:{"clip-rule":"evenodd","d":"M12 3a9 9 0 100 18 9 9 0 000-18zm-8 9a8 8 0 1116 0 8 8 0 01-16 0z"}})])
          )
        }
      }
    